
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"label":"Attributeinstellungen (Arbeitsmappe)"},"en":{"label":"Attribute settings (workbook)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();